import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SearchField from '../../elements/SearchField'
import Loader from '../../elements/Loader'
import { fetchStudents } from '../../../store/actions/studentsActions'
import { debounce } from '../../../utils'
import { ERROR, GET_STUDENTS, GETTING_STUDENTS } from '../../../store/types'
import ApplicantTableSnippet from '../applications/ApplicantTableSnippet'
import CloseIcon from '../../elements/icons/CloseIcon'
import CheckIcon from '../../elements/icons/CheckIcon'
import EmptyState from '../../elements/EmptyState'
// import { fetchAcademicSessions } from '../../../store/actions/academicSessionsActions'
// import SelectField from '../../elements/form/SelectField'
import ModalActionButton from '../../elements/ModalActionButton'
// import { fetchTerms } from '../../../store/actions/termsActions'
import NumberField from '../../elements/form/NumberField'
import { createAssessmentRecord, fetchAssessments } from '../../../store/actions/assessmentsActions'
import { fetchSubjects } from '../../../store/actions/subjectsActions'
import SelectField from '../../elements/form/SelectField'

const RecordAssessment = ({
    subject,
    assessment,
    close
}) => {

    const [recordPayload, setRecordPayload] = useState({})
    const [validationErrors, setValidationErrors] = useState({})
    
    const dispatch = useDispatch()
    const studentsSelector = useSelector(state => state.students)
    const subjectsSelector = useSelector(state => state.subjects)
    // const sessionsSelector = useSelector((state => state.academicSessions))
    const assessmentsSelector = useSelector((state => state.assessments))
    // const termsSelector = useSelector((state => state.terms))
    
    useEffect(() => {
        // dispatch(fetchAcademicSessions())
        dispatch({
            type: GETTING_STUDENTS,
            payload: false
        })
        dispatch({
            type: GET_STUDENTS,
            payload: []
        })
        // if(!subject) {
            dispatch(fetchSubjects('', 0, 0))
        // } 
        
        // if(!assessment) {
            dispatch(fetchAssessments('', 0, 0))
        // }
    
        return () => {
            
        }
    }, [assessment, dispatch, subject])

    const [activeClasses, setActiveClasses] = useState( subject ? subject.classes : null)

    useEffect(() => {
        if(recordPayload.class && recordPayload.class !== '') {
            dispatch(fetchStudents(`currentClass=${recordPayload.class}`, 1, 5))
            // dispatch(fetchStudents(`currentClass=${activeClasses.map(cl => cl.class._id).join(',')}`, 0, 5))
        }
    
        return () => {
            
        }
    }, [recordPayload.class, dispatch])
    
    const [percentageScore, setPercentageScore] = useState(0)
    useEffect(() => {
    
        setPercentageScore(Math.floor((recordPayload.score/recordPayload.outOf) * 100))
        return () => {
            
        }
    }, [recordPayload.score, recordPayload.outOf])
    
    const searchStudents = debounce((term) => {
        if(!term || term === '') {
            dispatch({
                type: GET_STUDENTS,
                payload: []
            })
        }
        dispatch(fetchStudents(`name=${term}&admissionNumber=${term}`, 0, 0))
    })

    const [selectedStudent, setSelectedStudent] = useState(null);  
    
    const toggleStudentSelect = (student) => {
        if(selectedStudent?._id === student._id) {
            setSelectedStudent(null)
        } else {
            setSelectedStudent(student)
        }
    }

    const validateForm = () => {
        let errors = {}

        if(selectedStudent === null) {
            errors.student = true
        }

        if(!recordPayload.score || recordPayload.score === '' || recordPayload.score < 0) {
            errors.score = true
        }

        // if(!recordPayload.outOf || recordPayload.outOf === '' || recordPayload.outOf < 1) {
        //     errors.outOf = true
        // }

        if(!subject && (!recordPayload.subject || recordPayload.subject === '')) {
            errors.subject = true
        }

        if(!assessment && (!recordPayload.assessment || recordPayload.assessment === '')) {
            errors.subject = true
        }

        setValidationErrors(errors)
        return errors
    }

    const pushRecord = () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        const payload = {
            ...recordPayload, 
            ...{
                student: selectedStudent._id,
                percentageScore,
                outOf: assessment ? assessment.totalMarks : recordPayload.outOf
            }
        }

        if(assessment) {
            payload.assessment = assessment._id
        }

        if(subject) {
            payload.subject = subject._id
        }

        dispatch(createAssessmentRecord(payload))
    }

    return (
        <div className='pt-[20px] border-t border-gray-300'>
            {!selectedStudent && <>
            <h3 className='text-sm font-[550]'>Find the Student</h3>
            <p className='text-sm text-gray-500'>Search for the student below to record their score for this subject</p>

            {subjectsSelector?.subjects?.subjects && subjectsSelector?.subjects?.subjects?.length > 0 && <div className='w-full mt-[10px] mb-[10px]'>
                <SelectField
                    selectOptions={subjectsSelector?.subjects?.subjects}
                    inputLabel="Select Subject"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    // preSelected=''
                    fieldId="subject"
                    hasError={validationErrors.subject}
                    preSelected={subject ? subject._id : ''}
                    preSelectedLabel={'_id'}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setRecordPayload({...recordPayload, ...{subject: value._id}})
                        setActiveClasses(value.classes)
                    }}
                    disabled={subject && subject !== null}
                />
            </div>}

            {activeClasses && activeClasses?.length > 0 && <div className='w-full mt-[10px] mb-[10px]'>
                <SelectField
                    selectOptions={activeClasses.map(cl => cl.class)}
                    inputLabel="Select Student Class"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    preSelected=''
                    fieldId="class"
                    hasError={false}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setRecordPayload({...recordPayload, ...{class: value._id}})
                        // setActiveClasses(value.classes)
                    }}
                />
            </div>}

            {assessmentsSelector?.assessments?.assessments && assessmentsSelector?.assessments?.assessments?.length > 0 && <div className='w-full mt-[10px] mb-[25px]'>
                <SelectField
                    selectOptions={assessmentsSelector?.assessments?.assessments}
                    inputLabel="Select Assessment"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    // preSelected=''
                    fieldId="assessment"
                    hasError={validationErrors.assessment}
                    preSelected={assessment ? assessment._id : ''}
                    preSelectedLabel={'_id'}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {
                        setRecordPayload({...recordPayload, ...{assessment: value._id}})
                    }}
                    disabled={assessment && assessment !== null}
                />
            </div>}

            <div className='w-full mt-[10px] mb-[10px]'>
                <SearchField 
                    placeholderText={`Search by student name or admission number`}
                    showResultsDropDown={false}
                    triggerSearch={(term)=>{searchStudents(term)}}
                    performingSearch={studentsSelector.loadingStudents}
                />
            </div>
            
            {studentsSelector.loadingStudents ? 
                <Loader />
            :
                <div className='overflow-y-scroll scrollbar-hidden max-h-[550px]'>
                    {studentsSelector?.students?.students?.length > 0 ? <div className='mt-[10px] w-full'>
                        {studentsSelector?.students?.students?.map((student, studentIndex) => (
                            <div key={studentIndex} className='flex items-start justify-between my-[10px]'>
                                <ApplicantTableSnippet 
                                    applicant={student} 
                                    showAdmissionNumber={true} 
                                    imageHeightClass='h-[35px]'
                                    imageWidthClass='w-[35px]'
                                />
                                <button onClick={()=>{toggleStudentSelect(student)}} className={`
                                    p-[2px] rounded transition duration-200 ${selectedStudent?._id === student._id ? 
                                    'bg-gray-600 text-white hover:text-gray-300 active:bg-black' 
                                    : 
                                    'bg-gray-100 text-gray-400  active:bg-white hover:text-gray-600'}
                                `}>
                                    {selectedStudent?._id === student._id ? 
                                        <CloseIcon className="w-5 h-5" /> 
                                        :
                                        <CheckIcon className="w-5 h-5" />
                                    }
                                </button>
                            </div>
                        ))}
                    </div>
                    :
                    <div className='mt-[10px]'>
                        <EmptyState emptyStateText={`No students found matching your search`} />
                    </div>
                    }
                </div>
            }
            </>}

            {selectedStudent && <>
                <div className='flex items-start justify-between my-[10px]'>
                    <ApplicantTableSnippet 
                        applicant={selectedStudent} 
                        showAdmissionNumber={true} 
                        imageHeightClass='h-[35px]'
                        imageWidthClass='w-[35px]'
                    />
                    <button onClick={()=>{toggleStudentSelect(selectedStudent)}} className={`
                        p-[7px] rounded transition duration-200 bg-gray-100 text-gray-600 active:bg-white hover:text-gray-600 text-xs font-medium
                    `}>
                        Change student
                    </button>
                </div>

                <div className='w-full flex items-start justify-between gap-x-[20px]'>
                    <div className='my-[10px] relative w-full'>
                        <NumberField
                            inputType="number" 
                            fieldId={`assessment-score`}
                            inputLabel="Student's assessment score" 
                            requiredField={true}
                            inputPlaceholder={`What the student scored`}
                            preloadValue={recordPayload.score || ''}
                            hasError={validationErrors.score} 
                            returnFieldValue={(value)=>{setRecordPayload({ ...recordPayload, score: value})}}
                        />
                    </div>
                    <div className='my-[10px] relative w-full'>
                        <NumberField
                            inputType="number" 
                            fieldId={`assessment-score-total`}
                            inputLabel="Max assessment score" 
                            inputPlaceholder={`Overall/maximum score`}
                            requiredField={true}
                            preloadValue={assessment.totalMarks || recordPayload.outOf || ''}
                            hasError={validationErrors.outOf} 
                            disabled={assessment.totalMarks}
                            returnFieldValue={(value)=>{setRecordPayload({ ...recordPayload, outOf: value})}}
                        />
                    </div>
                </div>

                {recordPayload.score > 0 && recordPayload.outOf > 0 && <div className='p-[10px]'>
                    <p className='text-sm text-gray-400'>Percentage: <span className='font-space-grotesk text-lg text-gray-700 font-medium'>{percentageScore}%</span></p>
                </div>}
            </>
            }

            {selectedStudent && <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={'Record Assessment Score'}
                    buttonAction={()=>{pushRecord()}}
                    processing={assessmentsSelector?.creatingAssessmentRecord}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>}
        </div>
    )
}

export default RecordAssessment